const PRE_APPROVAL_STATUSES: readonly string[] = [
  "PENDING_PRE_APPROVAL",
  "PRE_APPROVED",
  "PENDING_APPROVAL",
];

export const isApprovedOrLater = (status: string | undefined | null): boolean =>
  Boolean(status) &&
  !PRE_APPROVAL_STATUSES.includes(status as string) &&
  !(status as string).startsWith("REJECTED_") &&
  !(status as string).endsWith("_DRAFT");

export interface DryBulkTabFlags {
  isMainShippingAgent: boolean;
  isFottUser: boolean;
  isOperationsUser: boolean;
  hasDryBulkNomination: boolean;
  vesselHasVCN: boolean;
  vesselCallStatus: string | undefined | null;
}

export const canSeeOperationsDryBulk = (flags: DryBulkTabFlags): boolean =>
  (flags.isMainShippingAgent || flags.isFottUser || flags.isOperationsUser) &&
  flags.hasDryBulkNomination &&
  flags.vesselHasVCN &&
  isApprovedOrLater(flags.vesselCallStatus);

export const hasApprovedDryBulkNomination = (
  items: ReadonlyArray<{ nominationType?: string | null; status?: string | null }> | undefined,
): boolean =>
  items?.some(
    (item) =>
      item.nominationType === "DRY_BULK" &&
      (item.status === "APPROVED" || item.status === "CLOSED"),
  ) ?? false;
